module.exports = __webpack_public_path__ + "static/dhd-favicon-150-988decf27f2d8b1cd7adce8ce5b70868.png";